export default __webpack_public_path__ + "static/popup-mobile-b7ca59687bfa8632060c5c6e4f447d85.jpg";